<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import CardBase from '../../../common/CardBase.svelte';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { Readable } from 'svelte/store';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext, onMount } from "svelte";
import _ from "lodash";
import Select from 'svelte-select';
import { JanusSignonManager, JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import Item from '../AddressInputField/Item.svelte';
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: label = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.label) || '';
$: items = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.items) || [];
$: required = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.required) || undefined;
$: requiredKey = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.requiredKey;
$: valueKey = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.valueKey) || undefined;
$: profileSegment = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.profileSegment) || undefined;
$: profileField = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.profileField) || undefined;
$: defaultValue = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.defaultValue) || '';
$: selectZIndex = ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.selectZIndex) || '100';
$: isRequiredFromKey = requiredKey ? ($mergedParams || {})[requiredKey] : false;
$: isRequired = !_.isNil(required) ? required : isRequiredFromKey;
$: placeholder = isRequired ? `${label}*` : label;
const getOptionLabel = (option) => (option.name ? option.name : option);
const getSelectionLabel = (option) => (option.name ? option.name : option);
let value = defaultValue;
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    if (!profileField) {
        return;
    }
    const profileData = yield signonManager.getUserProfileSegment(profileSegment);
    const data = (profileData === null || profileData === void 0 ? void 0 : profileData.data) || {};
    if (profileField in data && !_.isNil(data[profileField])) {
        value = data[profileField];
    }
}));
let wrapperElement;
onMount(() => {
    let parent = wrapperElement;
    const _parent = wrapperElement.closest('.wrapper').parentElement;
    _parent.style.zIndex = "1";
    let i = 0;
    while (parent) {
        parent.style.overflow = 'visible';
        i++;
        if (i === 3) {
            parent.style.zIndex = '1';
        }
        parent = parent.parentElement;
    }
});
const handleChange = ({ detail }) => {
    if (detail) {
        value = detail.value;
    }
    else {
        value = undefined;
    }
    console.log(label + ': ', value);
    if (valueKey && !_.isNil(value)) {
        tabContext.setParam(valueKey, value);
    }
    else {
        tabContext.setParam(valueKey, '');
    }
};
</script>

<CardBase {element}>
    <div class="generic-select-input-field-wrapper" style="position:relative; z-index:{selectZIndex};" bind:this={wrapperElement}>
        <Select
            {items}
            {placeholder}
            optionIdentifier='value'
            {getSelectionLabel}
            {getOptionLabel}
            {Item}
            isClearable={true}
            isDisabled={false}
            isVirtualList={true}
            {value}
            on:select={handleChange}
            on:clear={handleChange}
        />
    </div>
</CardBase>

<style>.generic-select-input-field-wrapper {
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.generic-select-input-field-wrapper :global(.selectContainer) {
  border: 1px solid #D8D8D8 !important;
  border-radius: 6px;
  --padding: 0px 16px !important;
  --height: 40px;
  --inputFontSize: 12px;
}

.generic-select-input-field-wrapper :global(.listContainer) {
  box-shadow: 0px 0px 1px #b1afaf;
  overflow-y: unset;
}

:global(.generic-select-input-field-wrapper .selectContainer input, .generic-select-input-field-wrapper .selection, .generic-select-input-field-wrapper .customItem_name) {
  color: #000 !important;
  font-weight: normal !important;
}</style>